import round from './round';
/**
 *  Extra Principal Calculator
 * @param {Number} principalBalance Remiaing balance owed
 * @param {Number} interestRate Annual interest rate (ex: 9.5)
 * @param {Number} currentPayment Current payment amount (principal and interest only)
 * @param {Number} additionalPrincipal Additional principal payment
 * @param {Number} paymentsPerYear Total yearly payments (12 for monthly, 26 for biweekly)
 */
export function extraPrincipalCalculator(
  principalBalance,
  interestRate,
  currentPayment,
  additionalPrincipal = 0,
  paymentsPerYear = 12
) {
  const periodInterestRate = interestRate / 100 / paymentsPerYear;

  if (principalBalance * periodInterestRate > currentPayment) {
    return {
      previousNumberOfPayments: 0,
      newNumberOfPayments: 0,
      interestSavings: 0,
      annualReturn: 0,
      monthsAhead: 0,
      error:
        'At the terms you entered your mortgage will never be paid off. Please either reduce the principal, reduce the interest rate, increase the payment amount, or a combination of all three.',
    };
  }

  let currentCount = 0;
  let currentPrincipal = principalBalance;
  let currentAccumulativeInterest = 0;

  while (currentPrincipal > 0) {
    let interestPayment = periodInterestRate * currentPrincipal;
    currentAccumulativeInterest += interestPayment;
    currentPrincipal -= currentPayment - interestPayment;
    currentCount++;

    // Failsafe
    if (currentCount > 780) {
      return {
        previousNumberOfPayments: 0,
        newNumberOfPayments: 0,
        interestSavings: 0,
        annualReturn: 0,
        monthsAhead: 0,
        error:
          'At the terms you entered your mortgage will never be paid off. Please either reduce the principal, reduce the interest rate, increase the payment amount, or a combination of all three.',
      };
    }
  }

  let newCount = 0;
  let newPrincipal = principalBalance;
  let newAccumulativeInterest = 0;
  let newPayment = currentPayment + additionalPrincipal;
  while (newPrincipal > 0) {
    let interestPayment = periodInterestRate * newPrincipal;
    newAccumulativeInterest += interestPayment;
    newPrincipal -= newPayment - interestPayment;
    newCount++;

    // Failsafe
    if (newCount > 780) {
      return {
        previousNumberOfPayments: 0,
        newNumberOfPayments: 0,
        interestSavings: 0,
        annualReturn: 0,
        monthsAhead: 0,
        error:
          'At the terms you entered your mortgage will never be paid off. Please either reduce the principal, reduce the interest rate, increase the payment amount, or a combination of all three.',
      };
    }
  }

  const interestSavings = round(
    currentAccumulativeInterest - newAccumulativeInterest
  );

  const annualReturn = round(
    (interestSavings /
      (newCount * additionalPrincipal) /
      (newCount / paymentsPerYear)) *
      100
  );

  return {
    previousNumberOfPayments: currentCount,
    newNumberOfPayments: newCount,
    interestSavings,
    annualReturn,
    monthsAhead: round(((currentCount - newCount) / paymentsPerYear) * 12, 0),
    error: null,
  };
}
export default extraPrincipalCalculator;
